export default "__VITE_ASSET__B018IbDn__"